// extracted by mini-css-extract-plugin
export default {"wrapper":"Lesson_wrapper__v8Nub","title":"Lesson_title__+F5Ll","content":"Lesson_content__XxFCh","separator":"Lesson_separator__Zm1qC"};